export default __webpack_public_path__ + "static/media/018-sardine.5353b569.svg";